module.exports = __webpack_public_path__ + "static/media/basket.ed17afde.gif";